/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import LocationMainDto from './LocationMainDto';

/**
 * The LocationDto model module.
 * @module model/LocationDto
 * @version v1.0.0
 */
class LocationDto {
    /**
     * Constructs a new <code>LocationDto</code>.
     * @alias module:model/LocationDto
     */
    constructor() { 
        
        LocationDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LocationDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LocationDto} obj Optional instance to populate.
     * @return {module:model/LocationDto} The populated <code>LocationDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LocationDto();

            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('main')) {
                obj['main'] = ApiClient.convertToType(data['main'], [LocationMainDto]);
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('seq')) {
                obj['seq'] = ApiClient.convertToType(data['seq'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} code
 */
LocationDto.prototype['code'] = undefined;

/**
 * @member {String} id
 */
LocationDto.prototype['id'] = undefined;

/**
 * @member {Array.<module:model/LocationMainDto>} main
 */
LocationDto.prototype['main'] = undefined;

/**
 * @member {String} name
 */
LocationDto.prototype['name'] = undefined;

/**
 * @member {Number} seq
 */
LocationDto.prototype['seq'] = undefined;






export default LocationDto;

